/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesScorecardsEndpointsContractsScorecardsCreateScorecardRequest { 
    playerId?: string;
    teamId?: string;
    courseId?: string;
    roundId?: string;
    teeBoxId?: string;
    startScore?: number;
    finishScore?: number;
    roundScore?: number;
    startPlusMinus?: number;
    finishPlusMinus?: number;
    roundPlusMinus?: number;
    startSfpoints?: number;
    finishSfpoints?: number;
    roundSfpoints?: number;
    roundMatchResult?: number;
}